(function () {
    const searchLink = document.getElementById("searchlink")
    const searchLinkIcon = document.querySelectorAll(".s-item a")
    const searchModal = document.getElementById("searchmodal")
    const searchCancel = document.getElementById("searchcancel")

    if (searchLink) {
        searchLink.addEventListener("click", (e) => {
            e.preventDefault();
            openSearchModal()
        })
    }
    if (searchCancel) {
        searchCancel.addEventListener("click", (e) => {
            e.preventDefault();
            searchModal.style.display = "none";
        })
    }
    if (searchModal) {
        document.addEventListener("keyup", (e) => {
            if (e.key === "Escape") {
                if (searchModal.style.display = "block") {
                    searchModal.style.display = "none";
                }
            }
        })
    }
    if (searchLinkIcon && searchLinkIcon.length) {
        for (let i = 0; i < searchLinkIcon.length; i++) {
            searchLinkIcon[i].addEventListener("click", (e) => {
                e.preventDefault();
                //openSearchModal()
            })
        }
    }

    function openSearchModal() {
        searchModal.style.display = "block"
        document.getElementById("sitesearch").focus()
    }

    const spDoc = document.querySelector(".searchpanel")
    let mainnav = document.getElementById("mainnav")
    if (!mainnav) {
        mainnav = document.getElementById("navmain")
    }
    if (spDoc) {
        document.body.addEventListener("click", function (e) {
            //console.log(e.target)
            const sp = e.target.closest(".searchpanel")
            if (sp) {
                if (e.target.classList.contains("sclose")) {
                    spDoc.classList.remove("open")
                    mainnav.classList.remove("sp-open")
                }
            } else { 
                const sb = e.target.closest(".searchbtn")
                if (sb) {
                    if (spDoc.classList.contains("open")) {
                        spDoc.classList.remove("open")
                        mainnav.classList.remove("sp-open")
                    } else {
                        spDoc.classList.add("open")
                        mainnav.classList.add("sp-open")
                        spDoc.querySelector("input").focus()
                    }
                    e.preventDefault()
                } else {
                    spDoc.classList.remove("open")
                    mainnav.classList.remove("sp-open")
                }
            }

        })
    }
})();